import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class AwardCostCashTransactionLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly transactionType: string = "";

    @Attributes.Date()
    public readonly effectiveDate: Date = new Date();

    @Attributes.Float()
    public amount: number = 0;

    public readonly detail: string = "";

    public readonly isUnitConversion: boolean = false;

    // Client only properties / methods
}